import React from 'react';
import type { Context } from '@/types';

export const AppContext = React.createContext<Context>({ userPermissions: [], userRoles: [] });
